<div
  class="w-full min-h-screen flex flex-col items-center justify-start p-5 sm:p-8 md:p-10 lg:p-16 my-16">
  <div
    class="w-full flex flex-col font-extrabold font-secondary text-6xl sm:text-10xl md:text-16xl lg:text-18xl xl:text-20xl leading-[fit-content] my-10">
     <h1 i18n="@@autopark.form.title" class="mx-auto text-secondary-650 text-center max-w-[1500px]">
      Zapełnij flotą
       <br>
       <span class="text-primary-500">
         nasz plac
       </span>
     </h1>
  </div>
  <div id="formSection"
       class="max-w-[1000px] h-auto flex flex-col items-center justify-center bg-secondary-100 px-5 md:px-10 lg:px-16 pb-16 rounded-[2rem] md:rounded-[3rem] shadow-xl">
    <div
      class="max-md:w-full max-md:max-w-[90%] w-fit h-14 bg-linear-to-tr from-primary-300 to-primary-500 rounded-b-4xl inline-flex justify-center items-center text-secondary-300 gap-2 px-7">
      <span i18n="@@autopark.form.subtitle"
        class="text-xs md:text-sm lg:text-base">Zostaw nam swoje dane a wrócimy ze spersonalizowaną ofertą w 24h</span>
      <ng-icon name="tablerHeadset" size="1.5rem" class="min-w-[1.5rem] min-h-[1.5rem]"/>
    </div>
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()"
          class="flex flex-col gap-6 w-full h-auto mt-10">
      <div class="w-full flex flex-row items-start justify-center gap-2 md:gap-4 lg:gap-8">
        <div class="flex flex-col w-full h-auto">
          <p-floatlabel>
            <input pInputText
                   id="firstName"
                   [formControl]="contactForm.controls.fullName"
                   [invalid]="isInvalid('fullName')"
                   class="w-full"/>
            <label i18n="@@autopark.form.label.name-&-lastName" for="firstName">Imię i nazwisko</label>
          </p-floatlabel>
          @if (!contactForm.controls.fullName.touched || contactForm.controls.fullName.valid) {
            <small i18n="@@form.validation-hint.required" class="my-2 ml-2 text-secondary-800" id="firstName-help">To pole jest wymagane</small>
          }

          @if (isError('fullName'); as error) {
            <p-message severity="error" size="small" variant="simple" class="mt-2 ml-2">{{ error }}</p-message>
          }
        </div>
      </div>

      <div class="flex flex-col w-full h-auto">
        <p-floatlabel>
          <input pInputText
                 id="company"
                 [formControl]="contactForm.controls.company"
                 [invalid]="isInvalid('company')"
                 class="w-full"/>
          <label i18n="@@autopark.form.label.company" for="company">Firma</label>
        </p-floatlabel>

        @if (isError('company'); as error) {
          <p-message severity="error" size="small" variant="simple" class="mt-2">{{ error }}</p-message>
        }
      </div>

      <div class="flex flex-col gap-6 w-full h-auto">
        <label i18n="@@autopark.form.label.fleet-size" for="budgetRange" class="text-md text-primary-500 font-semibold">
          Jaka jest wielkość Twojej floty?
        </label>
        <p-slider id="budgetRange"
                  [formControl]="contactForm.controls.fleetSize"
                  [min]="minFleet"
                  [max]="maxFleet"
                  [step]="step"
                  class="w-full">
        </p-slider>
        <div i18n="@@autopark.form.sub-label.fleet-size" class="text-md text-secondary-900 font-primary">
          Wielkość floty: {{ contactForm.controls.fleetSize.value }} pojazdów
        </div>
      </div>

      <div class="w-full flex flex-row items-start justify-center gap-2 md:gap-4 lg:gap-8">
        <div class="flex flex-col w-full h-auto">
          <p-floatlabel>
            <input pInputText
                   id="email"
                   [formControl]="contactForm.controls.email"
                   [invalid]="isInvalid('email')"
                   class="w-full"/>
            <label i18n="@@autopark.form.label.email" for="email">e-mail</label>
          </p-floatlabel>
          @if (!contactForm.controls.email.touched || contactForm.controls.email.valid) {
            <small i18n="@@form.validation-hint.required" class="my-2 ml-2 text-secondary-800" id="email-help">To pole jest wymagane</small>
          }

          @if (isError('email'); as error) {
            <p-message severity="error" size="small" variant="simple" class="mt-2">{{ error }}</p-message>
          }
        </div>

        <div class="flex flex-col w-full h-auto">
          <p-inputgroup class="w-full">
            <p-inputgroup-addon>
              <span>+48</span>
            </p-inputgroup-addon>
            <p-floatlabel class="w-full">
              <p-inputmask
                id="tel"
                mask="999-999-999"
                [formControl]="contactForm.controls.phone"
                [invalid]="isInvalid('phone')"
                class="w-full"/>
              <label i18n="@@autopark.form.label.phone" for="tel">Telefon</label>
            </p-floatlabel>
          </p-inputgroup>

          @if (isError('phone'); as error) {
            <p-message severity="error" size="small" variant="simple" class="mt-2">{{ error }}</p-message>
          }
        </div>
      </div>

      <div class="inline-flex gap-2 items-center w-full h-auto">
        <p-checkbox
          id="terms"
          [formControl]="contactForm.controls.consentDataProcessing"
          [binary]="true">
        </p-checkbox>
        <div>
            <span i18n="@@autopark.form.consent.processing-personal-data.content" class="text-xs md:text-sm">
              Mam świadomość, że wysyłając wiadomość za pomocą formularza kontaktowego administrator
              „Gardocki SA Spółka z ograniczoną odpowiedzialnością" Spółka komandytowa jest uprawniony
              do przetwarzania moich danych osobowych w uzasadnionym interesie, w szczególności w celu
              udzielenia odpowiedzi na pytanie, nawiązania kontaktu, przedstawienia oferty, zgodnie z
              treścią zapytania, w formie telefonicznej lub elektronicznej.
            </span>

          @if (isError('consentDataProcessing'); as error) {
            <p-message severity="error" size="small" variant="simple" class="mt-2">{{ error }}</p-message>
          }
        </div>
      </div>

      <div class="inline-flex gap-2 items-center w-auto h-auto">
        <p-checkbox
          id="terms"
          [formControl]="contactForm.controls.consentPrivacyPolicy"
          [binary]="true">
        </p-checkbox>

        <div>
          <span i18n="@@autopark.form.consent.privacy-policy.content" class="text-xs md:text-sm">
          Zapoznałam/em się z informacją o administratorze danych osobowych
          <a class="text-primary-500" [href]="privacyPolicyUrl">Polityka prywatności</a>.
        </span>

          @if (isError('consentPrivacyPolicy'); as error) {
            <p-message severity="error" size="small" variant="simple" class="mt-2">{{ error }}</p-message>
          }
        </div>
      </div>

      <div class="w-full inline-flex justify-center my-5">
        <p-button
          type="submit"
          [rounded]="true"
          i18n-label="@@button.send-request"
          label="Wyślij zapytanie"
          [disabled]="contactForm.invalid || isProcessing()"
          styleClass="text-sm extra-padding !px-4">
        </p-button>
      </div>
    </form>
  </div>
</div>
